export default {
    stage: null,
    timer: null,
}